export const allMakesList: string[] = [
  "Acura",
  "Alfa Romeo",
  "AMC",
  "HUMMER",
  "MINI",
  "Scion",
  "Aston Martin",
  "Audi",
  "Bentley",
  "Ferrari",
  "FIAT",
  "Lamborghini",
  "BMW",
  "Lotus",
  "Maserati",
  "Maybach",
  "Buick",
  "Cadillac",
  "Chevrolet",
  "Chrysler",
  "Rolls-Royce",
  "DeLorean",
  "Datsun",
  "Dodge",
  "Eagle",
  "Ford",
  "Geo",
  "GMC",
  "Honda",
  "Hyundai",
  "INFINITI",
  "Isuzu",
  "Jaguar",
  "Jeep",
  "Kia",
  "Lexus",
  "Lincoln",
  "MAZDA",
  "Mercedes-Benz",
  "Mercury",
  "Mitsubishi",
  "Nissan",
  "Oldsmobile",
  "Plymouth",
  "Pontiac",
  "Porsche",
  "Land Rover",
  "Saab",
  "Saturn",
  "Subaru",
  "Suzuki",
  "Toyota",
  "Volkswagen",
  "Volvo",
  "Yugo",
  "Daewoo",
  "Bugatti",
  "Polestar",
  "RAM",
  "Genesis",
  "INEOS",
  "smart",
  "Tesla",
  "McLaren",
  "Fisker",
  "Freightliner",
  "SRT",
  "Karma",
  "Lucid",
  "Rivian",
  "VinFast"
].sort();
